import * as yup from 'yup';

export const announcementValidationSchema = yup.object().shape({
  title: yup
    .string()
    .required('Título é obrigatório')
    .min(5, 'O título deve ter pelo menos 5 caracteres'),
  description: yup
    .string()
    .required('Descrição é obrigatória')
    .min(10, 'A descrição deve ter pelo menos 10 caracteres'),
  type: yup
    .string()
    .oneOf(['ALL', 'PER_APARTMENT', 'PER_RESIDENT'], 'Tipo inválido')
    .required('Tipo é obrigatório'),
  models: yup
    .array()
    .when('type', {
      is: (type: string) => type === 'PER_APARTMENT' || type === 'PER_RESIDENT',
      then: (schema) => schema.min(1, 'Selecione pelo menos um item'),
      otherwise: (schema) => schema
    })
});